module.exports = __webpack_public_path__ + "static/media/daichuli.418c235f.svg";